import { jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { ChipMenu } from "../ChipMenu.js";
import { ChipMenuContextProvider } from "./ChipMenuContextProvider.js";
const ChipMenuWithContext = forwardRef(function ChipMenuWithContext2(props, ref) {
  const { open, setOpen } = props;
  const [localOpen, setLocalOpen] = useState(() => Boolean(open));
  return /* @__PURE__ */ jsx(ChipMenuContextProvider, { open: typeof open === "boolean" ? open : localOpen, setOpen: setOpen ?? setLocalOpen, children: /* @__PURE__ */ jsx(ChipMenu, { ...props, ref }) });
});
export {
  ChipMenuWithContext
};
//# sourceMappingURL=ChipMenuWithContext.js.map
